/**
 * Get Inbenta SDK script
 * @param   {object}  conf  Script configuration
 * @return  {object}        Inbenta SDK Script
 */
export default function(conf) {
  var script = {};

  // Set script src & type
  script.type = 'text/javascript';
  script.src = 'https://sdk.inbenta.io/chatbot/' + conf.version + '/inbenta-chatbot-sdk.js'

  // Set script integrity
  if (conf.integrity) {
    script.integrity = conf.integrity;
    script.crossorigin = 'anonymous'
  }

  return script;
}
